import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'ebw-monorepo-rank-selector-perc',
  templateUrl: './rank-selector-perc.component.html',
  styleUrls: ['./rank-selector-perc.component.scss']
})
export class RankSelectorPercComponent implements OnInit, OnChanges {
  @Input() valueRank: number | null = null;
  @Input() defaultValue = 0;
  @Input() label = 'Percentuale';

  @Output() rankChange = new EventEmitter<number>();

  control = new FormControl<number | null>(null, [Validators.min(0), Validators.max(100), Validators.pattern(/^\d+$/)]);

  ngOnInit() {
    // set default iniziale
    const initial = this.valueRank !== null && this.valueRank !== undefined ? this.valueRank : this.defaultValue;

    this.control.setValue(initial, { emitEvent: false });

    // ascolta cambi
    this.control.valueChanges.subscribe((val) => {
      if (this.control.valid && val !== null) {
        this.rankChange.emit(Number(val));
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['valueRank'] && !changes['valueRank'].firstChange) {
      const newVal = changes['valueRank'].currentValue;
      this.control.setValue(newVal, { emitEvent: false });
    }
  }

  /** blocca caratteri tipo e */
  blockInvalidKeys(event: KeyboardEvent) {
    const invalidKeys = ['e', 'E', '+', '-', ',', '.'];
    if (invalidKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  onPaste(event: ClipboardEvent) {
    const pasted = event.clipboardData?.getData('text') ?? '';

    if (!/^\d+$/.test(pasted)) {
      event.preventDefault();
      return;
    }

    const value = Number(pasted);
    if (value < 0 || value > 100) {
      event.preventDefault();
    }
  }
}
